class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* =========================================================
   CONFETE DA BARRA DA PROMOÇÃO
   10/10/2026: o mesmo efeito do Super 10/10 da Oval Club. Ao cruzar um marco
   (LEVE 3 e LEVE 5) o confete estoura do presente daquele marco (leque pra
   cima + respingo) e depois cai uma chuva do topo da gaveta, nas cores da
   promo (dourado, amarelo, branco, preto e o vermelho do laço do presente),
   com algumas bolinhas de futebol no meio.
   Espera a gaveta terminar de abrir: adicionando pela página do produto o
   carrinho muda com a gaveta ainda fechada e o confete nascia fora da tela.
   Com a barra antiga (sem "Visual Faixa da Promoção") usa as cores antigas.
   As metas vêm do data-cpb-tiers do snippets/progress-bar-unified.liquid.
   ========================================================= */

(function () {
  if (window.__cdrCpbConfettiInit) return;
  window.__cdrCpbConfettiInit = true;

  var CORES_PROMO = ['#ffc400', '#ffd84d', '#ffae00', '#ffffff', '#111111', '#e3000f', '#ffc400', '#ffd84d', '#ffffff', '#c40010'];
  var CORES_PB = ['#000000', '#1f1f1f', '#4d4d4d', '#8c8c8c', '#c8c8c8', '#ffffff', '#e3000f', '#c40010'];
  var BOLA =
    '<circle cx="12" cy="12" r="10.6" fill="#ffffff" stroke="#111111" stroke-width="1.3"/>' +
    '<path d="M12 8.4l3.42 2.49-1.3 4.02H9.88l-1.3-4.02z" fill="#111111"/>' +
    '<path d="M12 8.4V4.4M15.42 10.89l3.8-1.24M14.12 14.91l2.35 3.23M9.88 14.91l-2.35 3.23M8.58 10.89l-3.8-1.24" stroke="#111111" stroke-width="1.2" stroke-linecap="round" fill="none"/>';
  var ultimo = 0;
  var previousCount = null;
  var checkTimer = null;

  function rnd(a, b) { return a + Math.random() * (b - a); }

  function solta(host, marco) {
    var r = host.getBoundingClientRect();
    var W = r.width || window.innerWidth;
    var H = r.height > 0 ? r.height : window.innerHeight;
    var topo = Math.max(r.top, 0);
    var promo = !!document.querySelector('cart-drawer .cpf, #CartDrawer .cpf');
    var CORES = promo ? CORES_PROMO : CORES_PB;

    var palco = document.createElement('div');
    palco.className = 'cpb-confetti';
    palco.setAttribute('aria-hidden', 'true');
    palco.style.cssText = 'position:fixed;left:' + r.left + 'px;top:' + topo + 'px;width:' + W + 'px;height:' + H + 'px;overflow:hidden;pointer-events:none;z-index:2147483000;perspective:700px';
    document.body.appendChild(palco);

    // sai do presente do marco que acabou de ser alcançado (o 1º presente no LEVE 3, o do fim no LEVE 5)
    var marcos = document.querySelectorAll('cart-drawer .cpf__marco, #CartDrawer .cpf__marco');
    var alvo = marcos.length ? marcos[Math.min(marco, marcos.length - 1)] : null;
    var presente = alvo ? (alvo.querySelector('.cpf__presente') || alvo) : null;
    var pr = presente ? presente.getBoundingClientRect() : { left: r.left + W * 0.8, top: topo + 150, width: 30, height: 30 };
    var ox = pr.left + pr.width / 2 - r.left;
    var oy = pr.top + pr.height / 2 - topo;
    var anims = [];

    function cria() {
      var el;
      if (promo && Math.random() < 0.09) {
        var t = rnd(15, 21);
        el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        el.setAttribute('viewBox', '0 0 24 24');
        el.innerHTML = BOLA;
        el.style.width = t + 'px';
        el.style.height = t + 'px';
      } else {
        el = document.createElement('span');
        var f = Math.random(), w, h;
        if (f < 0.45) { w = rnd(9, 15); h = rnd(4, 7); el.style.borderRadius = '1px'; }
        else if (f < 0.75) { w = h = rnd(7, 10); el.style.borderRadius = '1px'; }
        else { w = h = rnd(6, 9); el.style.borderRadius = '50%'; }
        el.style.width = w + 'px';
        el.style.height = h + 'px';
        var cor = CORES[(Math.random() * CORES.length) | 0];
        el.style.background = cor;
        if (cor === '#ffffff') el.style.boxShadow = '0 0 0 0.5px rgba(0,0,0,.14)';
      }
      el.style.position = 'absolute';
      el.style.left = '0';
      el.style.top = '0';
      el.style.opacity = '0';
      el.style.willChange = 'transform, opacity';
      palco.appendChild(el);
      return el;
    }

    // trajetória simulada (gravidade + arrasto + balanço) e virada em quadros-chave
    function voa(el, x, y, vx, vy, atraso, explode) {
      var g = 900, k = explode ? 2.2 : 0.4, vt = rnd(230, 330);
      var giraZ = rnd(-600, 600), giraX = rnd(380, 900), z0 = rnd(0, 360);
      var balA = rnd(10, 28), balF = rnd(0.8, 1.5), balP = rnd(0, 6.28);
      var dt = 1 / 60, t = 0, px = x, py = y, quadros = [], passo = 0;
      while (t < 6) {
        vx -= vx * k * dt;
        vy += g * dt;
        vy -= vy * k * dt * 0.3;
        if (vy > vt) vy = vt;
        px += vx * dt;
        py += vy * dt;
        t += dt;
        passo++;
        if (passo % 6 === 0) {
          var bal = t > 0.35 ? balA * Math.sin(6.283 * balF * t + balP) * Math.min(1, (t - 0.35) * 2) : 0;
          quadros.push({ t: t, x: px + bal, y: py, rz: z0 + giraZ * t, rx: giraX * t });
        }
        if (py > H + 40) break;
      }
      var T = t;
      var kf = [{ transform: 'translate3d(' + x + 'px,' + y + 'px,0) rotateZ(' + z0 + 'deg) rotateX(0deg)', opacity: 1, offset: 0 }];
      quadros.forEach(function (q) {
        var o = Math.min(1, q.t / T);
        kf.push({ transform: 'translate3d(' + q.x.toFixed(1) + 'px,' + q.y.toFixed(1) + 'px,0) rotateZ(' + q.rz.toFixed(0) + 'deg) rotateX(' + q.rx.toFixed(0) + 'deg)', opacity: o > 0.88 ? Math.max(0, (1 - o) / 0.12) : 1, offset: o });
      });
      kf[kf.length - 1].offset = 1;
      anims.push(el.animate(kf, { duration: T * 1000, delay: atraso * 1000, easing: 'linear', fill: 'both' }));
    }

    var i, ang, vel;
    // estouro saindo do presente
    for (i = 0; i < 110; i++) {
      ang = rnd(-180, 0) * Math.PI / 180; vel = rnd(320, 760);
      voa(cria(), ox, oy, Math.cos(ang) * vel, Math.sin(ang) * vel, rnd(0, 0.08), true);
    }
    for (i = 0; i < 22; i++) {
      ang = rnd(10, 170) * Math.PI / 180; vel = rnd(150, 360);
      voa(cria(), ox, oy, Math.cos(ang) * vel, Math.sin(ang) * vel, rnd(0, 0.08), true);
    }
    // chuva caindo do topo
    for (i = 0; i < 130; i++) {
      voa(cria(), rnd(0, W), rnd(-90, -15), rnd(-30, 30), rnd(60, 160), rnd(0.1, 1.0), false);
    }
    Promise.all(anims.map(function (a) { return a.finished; })).then(function () {
      if (palco.parentNode) palco.parentNode.removeChild(palco);
    });
  }

  // marco: 0 = primeiro marco (LEVE 3), 1 = segundo (LEVE 5)
  function fireConfetti(marco) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!document.body || !document.body.animate) return;
    // o carrinho redesenha 2x ao adicionar pela página do produto: só 1 confete
    var agora = Date.now();
    if (agora - ultimo < 2500) return;
    ultimo = agora;
    var host =
      document.querySelector('cart-drawer .drawer__inner') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('cart-drawer') ||
      document.body;
    var anterior = null, parado = 0, inicio = Date.now();
    (function espera() {
      var r = host.getBoundingClientRect();
      var dentro = r.width > 0 && r.left < window.innerWidth - 10 && r.right > 10;
      parado = (anterior !== null && Math.abs(r.left - anterior) < 0.5 && dentro) ? parado + 1 : 0;
      anterior = r.left;
      if (parado >= 3) return solta(host, marco || 0);
      if (Date.now() - inicio > 6000) return; // a gaveta não abriu: não solta confete fora da tela
      requestAnimationFrame(espera);
    })();
  }

  function checkProgress() {
    var bar = document.querySelector('#CartDrawer [data-cpb-count], cart-drawer [data-cpb-count]');
    if (!bar) {
      // carrinho vazio: a barra some. Conta como 0, para comemorar se a 1ª adição já chegar num marco
      var gaveta = document.querySelector('cart-drawer');
      if (gaveta && gaveta.classList.contains('is-empty')) previousCount = 0;
      return;
    }
    var currentCount = parseInt(bar.getAttribute('data-cpb-count') || '0', 10);
    var tiers = (bar.getAttribute('data-cpb-tiers') || '')
      .split(',')
      .map(function (value) { return parseInt(value, 10); })
      .filter(function (value, index, values) { return value > 0 && values.indexOf(value) === index; })
      .sort(function (a, b) { return a - b; });
    // primeira leitura da página: nunca comemora (quem já tinha 3 no carrinho veria confete a cada visita)
    if (previousCount === null) {
      previousCount = currentCount;
      return;
    }
    var marco = -1;
    tiers.forEach(function (tier, index) {
      if (previousCount < tier && currentCount >= tier) marco = index;
    });
    previousCount = currentCount;
    if (marco >= 0) {
      // com a barra fluida (logo abaixo) o confete espera o amarelo chegar no presente
      if (window.cdrCpfNaChegada) window.cdrCpfNaChegada(marco, function () { fireConfetti(marco); });
      else fireConfetti(marco);
    }
  }

  function scheduleCheck() {
    window.clearTimeout(checkTimer);
    checkTimer = window.setTimeout(checkProgress, 180);
  }

  function initialize() {
    checkProgress();
    var observer = new MutationObserver(scheduleCheck);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-cpb-count']
    });
  }

  window.cdrFireCartConfetti = fireConfetti;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

/* =========================================================
   BARRA DA PROMOÇÃO FLUIDA (cdr-barra-fluida-v1, 13/10/2026)
   A cada mudança no carrinho (adicionar, +, -, remover) a gaveta é redesenhada
   inteira. Antes, a barra nova já nascia no valor final, a arte do topo voltava
   para o começo e as imagens (arte, presentes e fotos dos produtos) ficavam em
   branco por alguns quadros: era a "piscada".
   Agora, antes de a gaveta nova aparecer na tela:
   - as imagens que já estavam carregadas são reaproveitadas, então nada pisca;
   - a arte que corre e o brilho/pulo dos presentes seguem o relógio da página e
     continuam do ponto em que estavam;
   - o amarelo sai de onde estava e corre suave até o valor novo. O presente só
     acende (com um pulo) quando o amarelo chega nele, e o confete sai nessa hora;
   - ao abrir a gaveta pelo ícone do carrinho, o amarelo enche de 0 até o valor atual.
   Quem pediu menos movimento no sistema vê a barra parada no valor final.
   ========================================================= */
(function () {
  if (window.__cdrBarraFluida) return;
  window.__cdrBarraFluida = true;

  var reduz = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var temEscala = !!(window.CSS && CSS.supports && CSS.supports('scale', '1'));
  var gaveta = null;
  var obs = null;
  var verdade = null; // o que o carrinho diz agora (lido da barra que acabou de chegar)
  var mostrado = 0; // largura do amarelo na tela, em %
  var an = { de: 0, para: 0, t0: 0, dur: 800, ativo: false, espera: false, esperaDesde: 0, raf: 0, parado: 0, ultimoX: null };
  var guardadas = []; // imagens já carregadas que saíram da gaveta, prontas para voltar
  var naChegada = {}; // marco -> funções a chamar quando o amarelo chegar nele
  var ultimoDesenho = -1e9;
  var abertaEm = -1e9;
  var estavaAberta = false;

  function agora() { return window.performance ? performance.now() : Date.now(); }
  function suave(x) { return 1 - Math.pow(1 - x, 3); }
  function barraAtual() { return gaveta ? gaveta.querySelector('.cpf') : null; }
  function cada(lista, fn) { for (var i = 0; i < lista.length; i++) fn(lista[i], i); }

  // o estado real vem do Liquid: largura do amarelo, posição e "aceso" de cada marco, barra completa e mensagem
  function ler(barra) {
    var g = barra.querySelector('.cpf__ganho');
    var v = {
      pct: g ? parseFloat(g.style.width) || 0 : 0,
      pos: [],
      on: [],
      done: barra.classList.contains('cpf--done'),
      msg: ((barra.querySelector('.cpf__msg') || {}).textContent || '').trim()
    };
    cada(barra.querySelectorAll('.cpf__marco'), function (m) {
      v.pos.push(parseFloat(m.style.left) || 100);
      v.on.push(m.classList.contains('is-on'));
    });
    return v;
  }

  // desenha a barra com o amarelo em w%: o presente só acende quando o amarelo chega nele
  function pintar(barra, w, animando) {
    var v = barra.__cpf;
    if (!v) return;
    var g = barra.querySelector('.cpf__ganho');
    if (g) g.style.width = w.toFixed(2) + '%';
    var descendo = an.ativo && an.para < an.de;
    cada(barra.querySelectorAll('.cpf__marco'), function (m, i) {
      var aceso = w >= v.pos[i] - 0.6 && (v.on[i] || descendo);
      if (m.classList.contains('is-on') === aceso) return;
      m.classList.toggle('is-on', aceso);
      if (aceso && animando) chegou(m, i);
    });
    barra.classList.toggle('cpf--done', w >= 99.4 && (v.done || descendo));
  }

  // o amarelo chegou no presente: pulo do presente, anel de luz e o confete (se estava esperando)
  function chegou(marco, i) {
    if (temEscala && !reduz.matches && marco.animate) {
      var p = marco.querySelector('.cpf__presente');
      var b = marco.querySelector('.cpf__brilho');
      if (p) p.animate([{ scale: '1' }, { scale: '1.5', offset: 0.35 }, { scale: '0.92', offset: 0.7 }, { scale: '1' }], { duration: 700, easing: 'cubic-bezier(.3,.7,.4,1)' });
      if (b) b.animate([{ scale: '1', opacity: 0.9 }, { scale: '2.6', opacity: 0 }], { duration: 750, easing: 'cubic-bezier(.2,.7,.3,1)' });
    }
    var fila = naChegada[i];
    naChegada[i] = null;
    if (fila) cada(fila, function (f) { try { f(); } catch (e) {} });
  }

  function valorEm(t) {
    if (!an.ativo) return mostrado;
    var x = (t - an.t0) / an.dur;
    if (x <= 0) return an.de;
    if (x >= 1) return an.para;
    return an.de + (an.para - an.de) * suave(x);
  }

  // a gaveta terminou de deslizar? (o mesmo critério do confete: aberta e parada por 2 quadros)
  function gavetaParada() {
    if (!gaveta.classList.contains('active')) { an.parado = 0; return false; }
    var inner = gaveta.querySelector('.drawer__inner');
    if (!inner) return true;
    var r = inner.getBoundingClientRect();
    var dentro = r.width > 0 && r.left < window.innerWidth - 10 && r.right > 10;
    an.parado = dentro && an.ultimoX !== null && Math.abs(r.left - an.ultimoX) < 0.5 ? an.parado + 1 : 0;
    an.ultimoX = r.left;
    return an.parado >= 2;
  }

  function irPara(alvo, esperar) {
    var t = agora();
    if (an.ativo && Math.abs(an.para - alvo) < 0.01) return; // já está indo para lá (ao adicionar a gaveta redesenha 2x)
    var atual = valorEm(t);
    if (Math.abs(atual - alvo) < 0.01) { an.ativo = false; mostrado = alvo; return; }
    an.de = atual;
    an.para = alvo;
    an.t0 = t;
    an.dur = Math.min(1300, 600 + 7 * Math.abs(alvo - atual));
    an.ativo = true;
    an.espera = !!esperar;
    an.esperaDesde = t;
    an.parado = 0;
    an.ultimoX = null;
    if (!an.raf) an.raf = requestAnimationFrame(quadro);
  }

  function quadro() {
    an.raf = 0;
    var t = agora();
    if (an.espera) {
      // adicionando pela página do produto a gaveta ainda está abrindo: o amarelo espera ela parar
      if (gavetaParada() || t - an.esperaDesde > 1500) { an.espera = false; an.t0 = t + 60; }
      else an.t0 = t;
    }
    var w = valorEm(t);
    mostrado = w;
    var barra = barraAtual();
    if (barra && barra.__cpf) pintar(barra, w, true);
    if (an.espera || t - an.t0 < an.dur) { an.raf = requestAnimationFrame(quadro); return; }
    an.ativo = false;
    mostrado = an.para;
    if (barra && barra.__cpf) pintar(barra, an.para, true);
  }

  // a arte que corre e o brilho/pulo dos presentes seguem o relógio da página: a barra nova continua do mesmo ponto
  function sincronizar(raiz) {
    if (!document.getAnimations) return;
    try {
      cada(document.getAnimations(), function (a) {
        var alvo = a.effect && a.effect.target;
        if (!alvo || !a.animationName || !raiz.contains(alvo)) return;
        if (a.effect.getTiming().iterations !== Infinity) return;
        a.startTime = 0;
      });
    } catch (e) {}
  }

  function trocarMensagem(barra) {
    var m = barra.querySelector('.cpf__msg');
    if (!m || !m.animate || reduz.matches) return;
    m.animate([{ opacity: 0.35, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
  }

  function preparar(barra, inicial) {
    var v = ler(barra);
    barra.__cpf = v;
    var g = barra.querySelector('.cpf__ganho');
    if (g) g.style.transition = 'none'; // quem anima o amarelo é este script
    sincronizar(barra);
    var antes = verdade;
    verdade = v;
    if (inicial || reduz.matches) {
      an.ativo = false;
      mostrado = v.pct;
      pintar(barra, v.pct, false);
      return;
    }
    ultimoDesenho = agora();
    if (!antes && !an.ativo) mostrado = 0; // o carrinho estava vazio: o amarelo nasce do zero
    var aberta = gaveta.classList.contains('active') && ultimoDesenho - abertaEm > 400;
    irPara(v.pct, !aberta);
    pintar(barra, valorEm(agora()), false);
    if (antes && antes.msg !== v.msg) trocarMensagem(barra);
  }

  // ---- imagens: a gaveta nova reaproveita as que já estavam carregadas na antiga ----
  function chave(im) {
    return [im.getAttribute('src'), im.getAttribute('srcset'), im.getAttribute('sizes'), im.className, im.getAttribute('width'), im.getAttribute('height')].join('|');
  }
  function imagensDe(no) {
    if (no.nodeType !== 1) return [];
    if (no.tagName === 'IMG') return [no];
    return no.querySelectorAll ? no.querySelectorAll('img') : [];
  }
  function guardar(no) {
    cada(imagensDe(no), function (im) {
      if (im.complete && im.naturalWidth > 0) guardadas.push({ k: chave(im), el: im });
    });
    if (guardadas.length > 80) guardadas.splice(0, guardadas.length - 80);
  }
  function reaproveitar(no) {
    cada(imagensDe(no), function (novo) {
      if (!novo.parentNode || (novo.complete && novo.naturalWidth > 0)) return;
      var k = chave(novo);
      for (var j = guardadas.length - 1; j >= 0; j--) {
        if (guardadas[j].k === k && !guardadas[j].el.isConnected) {
          novo.parentNode.replaceChild(guardadas[j].el, novo);
          guardadas.splice(j, 1);
          return;
        }
      }
      // imagem nova de verdade (produto que acabou de entrar): carrega já, sem esperar o "lazy"
      if (novo.getAttribute('loading') === 'lazy') novo.setAttribute('loading', 'eager');
    });
  }

  // roda antes de a gaveta nova ser pintada na tela (o observador é chamado logo depois da troca)
  function aoMudar(lista) {
    var saiuBarra = false;
    cada(lista, function (m) {
      cada(m.removedNodes, function (n) {
        if (n.nodeType !== 1) return;
        guardar(n);
        if ((n.classList && n.classList.contains('cpf')) || (n.querySelector && n.querySelector('.cpf'))) saiuBarra = true;
      });
    });
    cada(lista, function (m) {
      cada(m.addedNodes, function (n) { if (n.nodeType === 1 && n.isConnected) reaproveitar(n); });
    });
    var barra = barraAtual();
    if (barra && !barra.__cpf) preparar(barra, false);
    else if (!barra && saiuBarra) { verdade = null; an.ativo = false; mostrado = 0; } // o carrinho esvaziou
    obs.takeRecords(); // as trocas de imagem feitas acima não precisam voltar para cá
  }

  function aoMudarClasse() {
    var aberta = gaveta.classList.contains('active');
    if (aberta && !estavaAberta) {
      abertaEm = agora();
      // abriu pelo ícone do carrinho (o carrinho não acabou de mudar): o amarelo enche de 0 até o valor atual
      var barra = barraAtual();
      if (barra) sincronizar(barra);
      if (barra && barra.__cpf && verdade && verdade.pct > 0 && !reduz.matches && abertaEm - ultimoDesenho > 500) {
        an.ativo = false;
        mostrado = 0;
        pintar(barra, 0, false);
        irPara(verdade.pct, true);
      }
    }
    estavaAberta = aberta;
  }

  // o confete (logo acima) chama isto: se o amarelo ainda está a caminho do presente, ele espera a chegada
  window.cdrCpfNaChegada = function (i, f) {
    var barra = barraAtual();
    var v = barra && barra.__cpf;
    if (v && an.ativo && v.pos[i] !== undefined && an.para >= v.pos[i] - 0.6 && valorEm(agora()) < v.pos[i] - 0.6) {
      (naChegada[i] = naChegada[i] || []).push(f);
      return;
    }
    f();
  };

  // depois que a página carregou, a arte e os presentes da gaveta já ficam prontos (antes só carregavam ao abrir)
  function carregarAntes() {
    if (!gaveta) return;
    cada(gaveta.querySelectorAll('img[loading="lazy"]'), function (im) { im.setAttribute('loading', 'eager'); });
  }

  function iniciar() {
    gaveta = document.querySelector('cart-drawer');
    if (!gaveta || !window.MutationObserver) return;
    estavaAberta = gaveta.classList.contains('active');
    var barra = barraAtual();
    if (barra) preparar(barra, true);
    obs = new MutationObserver(aoMudar);
    obs.observe(gaveta, { childList: true, subtree: true });
    new MutationObserver(aoMudarClasse).observe(gaveta, { attributes: true, attributeFilter: ['class'] });
    var ocioso = window.requestIdleCallback
      ? function (f) { requestIdleCallback(f, { timeout: 4000 }); }
      : function (f) { setTimeout(f, 2000); };
    // a barra que veio com a página pode ter começado a animar antes do CSS dela chegar: acerta o relógio no fim do carregamento
    function aoCarregar() {
      var b = barraAtual();
      if (b) sincronizar(b);
      ocioso(carregarAntes);
    }
    if (document.readyState === 'complete') aoCarregar();
    else window.addEventListener('load', aoCarregar, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();
